import {trigger, animate, transition, style, query} from '@angular/animations';

export const routerFadeTransition = trigger('routerFadeTransition', [

  transition('* <=> *', [

    query(':enter',
      [
        style({opacity: 0})
      ],
      {optional: true}
    ),

    query(':leave',
      [
        style({opacity: 1}),
        animate('0.2s', style({opacity: 0}))
      ],
      {optional: true}
    ),

    query(':enter',
      [
        style({opacity: 0}),
        animate('0.2s', style({opacity: 1}))
      ],
      {optional: true}
    )

  ])

]);

export const routerFadeSlideFromLeftTransition = trigger('routerFadeSlideFromLeftTransition', [

  transition('* <=> *', [

    query(':enter',
      [
        style({opacity: 0, transform: 'translateX(-100%)'})
      ],
      {optional: true}
    ),

    query(':leave',
      [
        style({opacity: 1}),
        animate('0.2s', style({opacity: 0, transform: 'translateX(-100%)'}))
      ],
      {optional: true}
    ),

    query(':enter',
      [
        style({opacity: 0}),
        animate('0.2s', style({opacity: 1, transform: 'translateX(0%)'}))
      ],
      {optional: true}
    )

  ])

]);

export const routerWipeTransition = trigger('routerWipeTransition', [

  transition('* => *', [

    query(':enter, :leave', style({position: 'fixed', width: '100%'}),
      {optional: true}),

    query(':enter',
      [
        style({transform: 'translateX(100%)'}),
        animate('0.2s cubic-bezier(.75,-0.48,.26,1.52)', style({transform: 'translateX(0%)'}))
      ],
      {optional: true}
    ),

    query(':leave',
      [
        style({transform: 'translateX(0%)'}),
        animate('0.2s cubic-bezier(.75,-0.48,.26,1.52)', style({transform: 'translateX(100%)'}))
      ],
      {optional: true}
    )

  ])

]);



// WEBPACK FOOTER //
// ./src/app/router.animations.ts